import * as React from "react";
import { getCourses } from "../../libs/courses";
import Loader from "../core/Loader";
import CenterDiv from "../core/CenterDiv";
import usePromise from "../hooks/usePromise";
import CourseAssignment from "./CourseAssignment";

interface IProps {
  userContext: IUserContextNormalized;
}

function MyAssignments({ userContext }: IProps) {
  const courseIds = userContext.user.courses.map(c => c.id);

  const [courses, { loading }] = usePromise(() => getCourses(courseIds), []);

  if (loading) {
    return <Loader />;
  } else if (courses.length < 1) {
    return (
      <>
        <CenterDiv>
          <i className="fa fa-3x fa-inbox" />
        </CenterDiv>
        <CenterDiv>
          <p>You don't have any assigned courses.</p>
        </CenterDiv>
      </>
    );
  }

  return (
    <>
      {courses.map(course => (
        <CourseAssignment
          key={course.id}
          course={course}
          user={userContext.user}
        />
      ))}
    </>
  );
}

export default MyAssignments;



// WEBPACK FOOTER //
// ./app/javascript/components/courses/MyAssignments.tsx